import { Directive } from '@angular/core';

@Directive({
  selector: '[appMomentDateAdapter]'
})
export class MomentDateAdapterDirective {

  constructor() { }

}
